/** Number of digits in the verification code */
export const DIGITS = 6;
